function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React from "react";
import makeCancelable from "./make-promise-cancelable";
var states = {
  loading: "loading",
  rejected: "rejected",
  resolved: "resolved"
};

var reducer = function reducer(state, action) {
  switch (action.type) {
    case states.loading:
      return {
        error: undefined,
        result: undefined,
        loading: true
      };

    case states.resolved:
      return {
        error: undefined,
        result: action.payload,
        loading: false
      };

    case states.rejected:
      return {
        error: action.payload,
        result: undefined,
        loading: false
      };

    default:
      return state;
  }
};

var initial_state = {
  error: undefined,
  result: undefined,
  loading: false
};

var usePromiseResolver = function usePromiseResolver(promiseFn, dependencies) {
  var _React$useReducer = React.useReducer(reducer, initial_state),
      _React$useReducer2 = _slicedToArray(_React$useReducer, 2),
      _React$useReducer2$ = _React$useReducer2[0],
      loading = _React$useReducer2$.loading,
      result = _React$useReducer2$.result,
      error = _React$useReducer2$.error,
      dispatch = _React$useReducer2[1];

  var lastPromise = React.useRef();

  var cancelPromise = function cancelPromise() {
    if (lastPromise && lastPromise.current && typeof lastPromise.current.cancel === "function") {
      lastPromise.current.cancel();
    }
  };

  var resolvePromise = function resolvePromise() {
    dispatch({
      type: states.loading
    });
    cancelPromise();
    lastPromise.current = makeCancelable(promiseFn());
    lastPromise.current.promise.then(function (res) {
      dispatch({
        type: states.resolved,
        payload: res
      });
    }).catch(function (e) {
      if (!e.isCanceled) {
        dispatch({
          type: states.rejected,
          payload: error
        });
      }
    });
  };

  React.useEffect(resolvePromise, dependencies);
  return [result, loading, error, resolvePromise];
};

export default usePromiseResolver;